/*
  src/redux/impersonate/constants.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'intro', action].join('/');
}

export const INTRO_STARTED = createConstant('INTRO_STARTED');
export const INTRO_ADVANCED = createConstant('INTRO_ADVANCED');
export const INTRO_COMPLETED = createConstant('INTRO_COMPLETED');



// WEBPACK FOOTER //
// ./src/shared/redux/intro/constants.js